import { Fragment, useEffect, useState } from "react";
import styles from "./ExpenseRecovery.module.css";
import store from "../../Store/Store";
import axios from "axios";
import config from "../../config/config";
import { observer } from "mobx-react";

const ExpenseRecovery = observer(() => {
  const [yearOptions, setYearOptions] = useState([]);
  const [selectedYear, setSelectedYear] = useState("");
  const [openModel, setOpenModel] = useState(false);
  const [selectedMonth, setSelectedmonth] = useState("");
  const [gotResponse, setGotResponse] = useState(false);
  const [months, setMonths] = useState([
    { number: 1, name: "January", status: "yet_to_generate" },
    { number: 2, name: "February", status: "yet_to_generate" },
    { number: 3, name: "March", status: "yet_to_generate" },
    { number: 4, name: "April", status: "yet_to_generate" },
    { number: 5, name: "May", status: "yet_to_generate" },
    { number: 6, name: "June", status: "yet_to_generate" },
    { number: 7, name: "July", status: "yet_to_generate" },
    { number: 8, name: "August", status: "yet_to_generate" },
    { number: 9, name: "September", status: "yet_to_generate" },
    { number: 10, name: "October", status: "yet_to_generate" },
    { number: 11, name: "November", status: "yet_to_generate" },
    { number: 12, name: "December", status: "yet_to_generate" },
  ]);

  const generateYearOptions = (startYear) => {
    const currentYear = new Date().getFullYear();
    const years = [];
    for (let year = currentYear; year >= startYear; year--) {
      years.push(year);
    }
    return years;
  };

  useEffect(() => {
    setSelectedYear("")
    setGotResponse(false)
    const startYear = 2024;
    setYearOptions(generateYearOptions(startYear));
  }, [store.refresh]);

  const handleYearChange = (e) => {
    setGotResponse(false);
    setSelectedYear(e.target.value);
    const obj = {
      ledger_label: store.Company_Id,
      year: e.target.value,
    };

    try {
      let tokens = localStorage.getItem("authToken");
      let parsedTokens = JSON.parse(tokens);
      let payload = {
        method: "post",
        maxBodyLength: Infinity,
        url: `${config.node_api_endpoint}/cupi/admin/get_rejected_spends_report_list`,
        headers: {
          aws_cognito_id_token: parsedTokens.IdToken,
          aws_cognito_access_token: parsedTokens.AccessToken,
          "Content-Type": "application/json",
        },
        data: obj,
      };
      axios
        .request(payload)
        .then((response) => {
          setGotResponse(true);
          const apiData = response.data.data.report_status_and_links;
          console.log("API response:", JSON.stringify(apiData));
          const updatedMonths = months.map((month) => {
            const monthData = apiData[month.number];
            return {
              ...month,
              status: monthData?.report_status || "yet_to_generate",
              url: monthData?.url || null,
            };
          });
          setMonths(updatedMonths);
        })
        .catch((err) => {
          console.log("Error fetching data:", err);
        });
    } catch (err) {
      console.log("Error:", err);
    }
  };

  const handleyet_to_generate = (month) => {
    setSelectedmonth(month);
    console.log(`Generating report for ${month} ${selectedYear}`);
    setOpenModel(true);
  };

  const handleDownloadReport = (month, url) => {
    setSelectedmonth(month);
    console.log(`Downloading report for ${month} ${selectedYear}`);
    if (url) {
      window.open(url, "_blank");
    }
  };

  const handleReportskipped = (month) => {
    console.log(`Report skipped for ${month} ${selectedYear}`);
  };

  const CreateAndDownloadCsv = () => {
    console.log("selectedMonth", selectedMonth);
    let monthNumber = "";
    months.map((res) => {
      if (res.name == selectedMonth) {
        console.log("res.name-------->", res.name);
        monthNumber = res.number;
      }
    });

    const obj = {
      ledger_label: store.Company_Id,
      year: selectedYear,
      month: monthNumber,
    };

    try {
      let tokens = localStorage.getItem("authToken");
      let parsedTokens = JSON.parse(tokens);
      let payload = {
        method: "post",
        maxBodyLength: Infinity,
        url: `${config.node_api_endpoint}/cupi/admin/generate_rejected_spends_report`,
        headers: {
          aws_cognito_id_token: parsedTokens.IdToken,
          aws_cognito_access_token: parsedTokens.AccessToken,
          "Content-Type": "application/json",
        },
        data: obj,
      };
      axios
        .request(payload)
        .then((response) => {
          const apiData = response.data.data.report_status_and_links;
          console.log("API response:", JSON.stringify(apiData));
          const updatedMonths = months.map((month) => {
            const monthData = apiData[month.number];
            if (monthData?.url) {
              window.open(monthData?.url, "_blank");
            }
            return {
              ...month,
              status: monthData?.report_status || "yet_to_generate",
              url: monthData?.url || null,
            };
          });
          setMonths(updatedMonths);
        })
        .catch((err) => {
          console.log("Error fetching data:", err);
        });
    } catch (err) {
      console.log("Error:", err);
    }
    setOpenModel(false);
  };

  // Function to check if the month should be visible
  const isMonthVisible = (monthNumber) => {
    const today = new Date();
    const currentYear = today.getFullYear();
    const currentMonth = today.getMonth() + 1; // getMonth() is 0-based
    const currentDay = today.getDate();

    // If selected year is not the current year, show all months
    if (Number(selectedYear) !== currentYear) {
      return true;
    }

    // For the current year, show the month only if today is after the 26th of that month
    if (monthNumber < currentMonth) {
      return true; // Past months are always visible
    } else if (monthNumber === currentMonth) {
      return currentDay > 25; // Current month is visible only after the 26th
    }
    return false; // Future months are not visible
  };

  return (
    <Fragment>
      <div className={styles.Container}>
        <div className={styles.ContainerHeading}>
          Generate Expense Recovery Report
        </div>
        <div>
          <select
            className={styles.Filter}
            value={selectedYear}
            onChange={handleYearChange}
          >
            <option value="" disabled>
              Select Year
            </option>
            {yearOptions.map((year) => (
              <option key={year} value={year}>
                {year}
              </option>
            ))}
          </select>
        </div>
        {selectedYear && gotResponse ? (
          <div className={styles.TableContainer}>
            <table className={styles.ReportTable}>
              <tbody className={styles.TableBody}>
                {months
                  .filter((month) => isMonthVisible(month.number))
                  //.reverse()//to reverse the months
                  .map((month) => (
                    <tr key={month.name} className={styles.TableRow}>
                      <td className={styles.TableMonth}>{month.name}</td>
                      <td className={styles.TableButton}>
                        {console.log("isUserViewAdmin",store.isUserViewAdmin)}
                        {console.log("store.isUserGlobalViewAdmin ",store.isUserGlobalViewAdmin )}
                        {month.status === "yet_to_generate" && //DONT ALLOW VIEW ADMIN
                          (!store.isUserViewAdmin &&!store.isUserGlobalViewAdmin  ? (
                            <button
                              className={styles.GenerateButton}
                              onClick={() => handleyet_to_generate(month.name)}
                            >
                              Generate
                            </button>
                          ) : (
                            <button className={styles.GenerateButton2}>
                              Generate
                            </button>
                          ))}
                        {month.status === "generated" && (
                          <button
                            className={styles.GenerateButton}
                            onClick={() =>
                              handleDownloadReport(month.name, month.url)
                            }
                          >
                            Download
                          </button>
                        )}
                        {month.status === "skipped" && (
                          <button
                            className={styles.skippedButton}
                            onClick={() => handleReportskipped(month.name)}
                          >
                            Report skipped
                          </button>
                        )}
                      </td>
                    </tr>
                  ))}
              </tbody>
            </table>
          </div>
        ) : (
          <div className={styles.NoTableData}>
            This report contains the list of users and the total amount of their
            rejected transactions, which is to be recovered from them.
          </div>
        )}
      </div>
      {openModel && (
        <div
          className={styles.model}
          onClick={() => {
            setOpenModel(false);
          }}
        >
          <button
            className={styles.model1}
            onClick={(e) => {
              e.stopPropagation();
            }}
          >
            <div
              className={styles.modelHeading}
            >{`Generate ${selectedMonth} Report?`}</div>
            <div className={styles.modelContainer}>
              <div className={styles.modelContainerWarning}>
                <img
                  className={styles.escrowLogo}
                  alt=""
                  src="/Exclamation-orange-icon.svg"
                />
                This report can only be generated once this month. All
                rejections after this will go to next month.
              </div>
              <div className={styles.modelContainerFileInfo}>
                <img
                  className={styles.escrowLogo1}
                  alt=""
                  src="/csv-file-icon.svg"
                />
                {`${selectedYear} ${selectedMonth} report`}
              </div>
              <div className={styles.modelContainerButton}>
                <button
                  className={styles.CancelButton}
                  onClick={() => {
                    setOpenModel(false);
                  }}
                >
                  Cancel
                </button>
                <button
                  className={styles.ConfirmButton}
                  onClick={() => {
                    CreateAndDownloadCsv();
                  }}
                >
                  Confirm & Download
                </button>
              </div>
            </div>
          </button>
        </div>
      )}
    </Fragment>
  );
});

export default ExpenseRecovery;
